var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7321 6.79985C6.10029 6.79985 6.39876 7.09832 6.39876 7.46651V11.4665C6.39876 11.8347 6.10029 12.1332 5.7321 12.1332C5.36391 12.1332 5.06543 11.8347 5.06543 11.4665V7.46651C5.06543 7.09832 5.36391 6.79985 5.7321 6.79985Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39876 6.79985C8.76695 6.79985 9.06543 7.09832 9.06543 7.46651V11.4665C9.06543 11.8347 8.76695 12.1332 8.39876 12.1332C8.03057 12.1332 7.7321 11.8347 7.7321 11.4665V7.46651C7.7321 7.09832 8.03057 6.79985 8.39876 6.79985Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.332 3.26652V2.73317C10.332 1.62281 9.46688 0.666504 8.33203 0.666504H5.66536C4.53052 0.666504 3.66536 1.62281 3.66536 2.73317V3.26652H0.998698C0.630508 3.26652 0.332031 3.565 0.332031 3.93319C0.332031 4.30138 0.630508 4.59985 0.998698 4.59985H1.66536V13.2665C1.66536 14.3769 2.53052 15.3332 3.66536 15.3332H10.332C11.4669 15.3332 12.332 14.3769 12.332 13.2665V4.59985H12.9987C13.3669 4.59985 13.6654 4.30138 13.6654 3.93319C13.6654 3.565 13.3669 3.26652 12.9987 3.26652H10.332ZM5.66536 1.99984C5.32745 1.99984 4.9987 2.29714 4.9987 2.73317V3.26652H8.9987V2.73317C8.9987 2.29714 8.66994 1.99984 8.33203 1.99984H5.66536ZM10.9987 4.59985H2.9987V13.2665C2.9987 13.7025 3.32745 13.9998 3.66536 13.9998H10.332C10.6699 13.9998 10.9987 13.7025 10.9987 13.2665V4.59985Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.1c469eb369371124eed08176fd3323ae.svg";
export { ForwardRef as ReactComponent };